// src/Components/Orders Main/utils/statusMaps.js
import {
  CheckCircle2, XCircle, Clock, Truck, Bike, Utensils, Package, BadgeCheck, Handshake
} from "lucide-react";

export const STATUS_META = {
  received:        { label: "Received",        color: "#0369A1", icon: Clock },
  paid:            { label: "Paid",            color: "#0E7490", icon: BadgeCheck },
  accepted:        { label: "Accepted",        color: "#047857", icon: Handshake },
  prepared:        { label: "Prepared",        color: "#7C3AED", icon: Utensils },
  dispatched:      { label: "Dispatched",      color: "#2563EB", icon: Truck },
  delivered:       { label: "Delivered",       color: "#16A34A", icon: CheckCircle2 },
  completed:       { label: "Completed",       color: "#15803D", icon: CheckCircle2 },
  driver_assigned: { label: "Driver Assigned", color: "#6B21A8", icon: Bike },
  driver_confirmed:{ label: "Driver Confirmed",color: "#4C1D95", icon: Bike },
  delivery_picked: { label: "Picked",          color: "#1D4ED8", icon: Package },
  rejected:        { label: "Rejected",        color: "#DC2626", icon: XCircle },
  refunded:        { label: "Refunded",        color: "#B91C1C", icon: XCircle },
  "ready_for_dinning": { label: "Ready: Dine", color: "#6D28D9", icon: Utensils },
  "ready_for_takeway": { label: "Ready: Take", color: "#7C3AED", icon: Utensils },
};

export const ORDER_TYPE_META = {
  home_delivery: { label: "Home Delivery", color: "#334155" },
  takeaway:      { label: "Takeaway",      color: "#0F766E" },
  office_order:  { label: "Office Order",  color: "#4338CA" },
  car_order:     { label: "Car Order",     color: "#A16207" },
  dinning:       { label: "Dine In",       color: "#7C3AED" },
};
